module.exports = __webpack_public_path__ + "img/anything.2e62d182.png";